// imports
import checkElement from '../utils/check-for-element';
import isMobile from '../utils/is-mobile';
import scroll from '../utils/scroll-lock';

const header = document.getElementById('header');
const headerMain = header.querySelector('.header-main');
const mainMenu = '.header-main__menu .main__items--level-0';

const headerDropdownOpen = 'header--dropdown-open';
const menuDropdown = 'menu__dropdown';
const menuItemOpen = 'menu-item--open';

let onMobile = isMobile();
let dropdownOpen = false;
let windowWidth = window.innerWidth;

const closeMenuDropdown = () => {
  const openMenuItem = header.querySelector(`.${menuItemOpen}`);
  if (openMenuItem) {
    // remove item open class
    openMenuItem.classList.remove(menuItemOpen);
    // reset dropdown height
    const itemOpenedDropdown = openMenuItem.querySelector(`.${menuDropdown}`);
    itemOpenedDropdown.style.setProperty('--menu-dropdown-height', '');
  }
  header.classList.remove(headerDropdownOpen);
  // allow scrolling
  scroll.unlock();
  dropdownOpen = false;
};

// @todo can probably move to utils at some point
const handleCloseEvents = () => {
  headerMain.addEventListener('click', ({ target }) => {
    // exit if we're on mobile,
    // bc we're listening for other events
    if (onMobile) {
      return;
    }

    // close if clicked on X
    if (target.classList.contains('modal__close--dropdown')) {
      closeMenuDropdown();
    }

    // close if clicked on overlay
    if (target.classList.contains('modal-overlay--header')) {
      closeMenuDropdown();
    }
  });
};

const toggleMenuDropdown = (menu) => {
  const rootLinksWithChildren = [
    ...menu.querySelectorAll('.main__link--has-children.main__link--level-0'),
  ];

  rootLinksWithChildren.forEach((link) => {
    link.addEventListener('click', (event) => {
      // exit if we're on mobile,
      // bc we're listening for other events
      if (onMobile) {
        return;
      }

      // prevent link default functionality
      event.stopImmediatePropagation();
      event.preventDefault();

      const { target } = event;
      const menuItem = target.parentNode;
      const itemOpenedDropdown = menuItem.querySelector(`.${menuDropdown}`);
      const menuItemIsOpen = menuItem.classList.contains(menuItemOpen);
      dropdownOpen = menuItemIsOpen;

      // reset dropdown height
      itemOpenedDropdown?.style.setProperty('--menu-dropdown-height', '');

      // remove open classes
      const menuItemWithClassOpen = menuItem
        .closest('.menu-items')
        .querySelector(`.${menuItemOpen}`);
      if (menuItemWithClassOpen) {
        menuItemWithClassOpen.classList.remove(menuItemOpen);
      }

      // toggle dropdown display if already open
      if (dropdownOpen) {
        closeMenuDropdown();
      } else {
        menuItem.classList.add(menuItemOpen);
        header.classList.add(headerDropdownOpen);

        // update dropdown height
        itemOpenedDropdown.style.setProperty(
          '--menu-dropdown-height',
          `${itemOpenedDropdown.scrollHeight}px`,
        );

        // prevent scrolling
        scroll.lock();

        // update global variables
        dropdownOpen = true;
      }
    });
  });
};

(() => {
  if (header) {
    // I think menu extras need some time to load :/
    checkElement(mainMenu).then((m) => toggleMenuDropdown(m));
    handleCloseEvents();
  }
})();

if (header) {
  // Resize event is being triggered on scroll for mobile devices,
  // so a simple solution would be to check if the width has actually changed.
  // @todo I used this on other resize listeners,
  // maybe we create an util function at some point for this
  window.addEventListener('resize', () => {
    if (window.innerWidth !== windowWidth) {
      // Update the window width for next time
      windowWidth = window.innerWidth;
      // update the on mobile check
      onMobile = isMobile();
      // only call the close function if if's open,
      // else the page scrolls to the top
      const dropdown = header.querySelector(
        `.${menuItemOpen} .${menuDropdown}`,
      );
      if (dropdownOpen && dropdown) {
        closeMenuDropdown();
      }
    }
  });

  // close menu on ESC
  window.addEventListener('keydown', ({ key }) => {
    const dropdown = header.querySelector(`.${menuItemOpen} .${menuDropdown}`);
    if (dropdownOpen && key === 'Escape' && dropdown) {
      closeMenuDropdown();
    }
  });
}
